import { styled } from '@linaria/react'
import 'blaze-slider/dist/blaze.css'

import sevenEleven from '../../assets/footer/7eleven.webp'
import banorte from '../../assets/footer/banorte.webp'
import bbva from '../../assets/footer/bbva.webp'
import benavides from '../../assets/footer/benavides.webp'
import bodegaaurrera from '../../assets/footer/bodegaaurrera.webp'
import calimax from '../../assets/footer/calimax.webp'
import cash from '../../assets/footer/cash.webp'
import circulok from '../../assets/footer/circulok.webp'
import extra from '../../assets/footer/extra.webp'
import farmaciadelahorro from '../../assets/footer/farmaciadelahorro.webp'
import farmaciaroma from '../../assets/footer/farmaciaroma.webp'
import lacomer from '../../assets/footer/lacomer.webp'
import mastercard from '../../assets/footer/mastercard.webp'
import oxxo from '../../assets/footer/oxxo.webp'
import paynet from '../../assets/footer/paynet.webp'
import sams from '../../assets/footer/sams.webp'
import santamaria from '../../assets/footer/santamaria.webp'
import soriana from '../../assets/footer/soriana.webp'
import spei from '../../assets/footer/spei.webp'
import stp from '../../assets/footer/stp.webp'
import teleingreso from '../../assets/footer/teleingreso.webp'
import visa from '../../assets/footer/visa.webp'
import walmart from '../../assets/footer/walmart.webp'
import bancomer from '../../assets/footer/bancomer.webp'
import hsbc from '../../assets/footer/hsbc.webp'
import santader from '../../assets/footer/santader.webp'
import scotiabank from '../../assets/footer/scotiabank.webp'
import useBlazeSlider from '../../hooks/useBlazeSlider'
import newcastle from '../../assets/footer/newcastle.webp'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const Container = styled.div`
  padding: 0 20px;
  @media (min-width: 1200px) {
    padding: 0;
  }
`

const PaymentLogos = styled.div`
  padding: 36px 0;
  border-top: 1px solid var(--highlight);
  @media (min-width: 1200px) {
    padding: 40px 40px 40px 30px;
  }
`

const PaymentLogo = styled.div`
  padding: 0 12px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: fit-content;
  img {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
  }
`

const NewCastle = styled(LazyLoadImage)`
  width: 250px;
  display: block;
  margin: 0 auto 24px;
  aspect-ratio: 932 / 267;
  @media (min-width: 1200px) {
    width: 300px;
    margin: 0 auto 36px;
  }
`

const PAYMENT_LOGOS = [
  spei,
  oxxo,
  mastercard,
  visa,
  sevenEleven,
  banorte,
  bbva,
  benavides,
  bodegaaurrera,
  calimax,
  cash,
  circulok,
  extra,
  farmaciadelahorro,
  farmaciaroma,
  lacomer,
  paynet,
  sams,
  santamaria,
  soriana,
  stp,
  teleingreso,
  walmart,
  bancomer,
  hsbc,
  santader,
  scotiabank
] as const

const Sponsors = () => {
  const { elRef } = useBlazeSlider({
    all: {
      loop: true,
      enableAutoplay: true,
      slidesToShow: 4,
      autoplayInterval: 50,
      transitionDuration: 2000,
      transitionTimingFunction: 'linear',
    },
    '(min-width: 768px)': {
      slidesToShow: 6,
    },
    '(min-width: 1280px)': {
      slidesToShow: 10,
    },
  })

  return (
    <Container>
      <PaymentLogos>
        <NewCastle src={newcastle} alt="New Castle" />
        <div className="blaze-slider" ref={elRef}>
          <div className="blaze-container">
            <div className="blaze-track-container">
              <div className="blaze-track">
                {PAYMENT_LOGOS.map((logo, index) => (
                  <PaymentLogo key={index}>
                    <LazyLoadImage
                      src={logo}
                      style={{ aspectRatio: '49 / 29' }}
                    />
                  </PaymentLogo>
                ))}
              </div>
            </div>
          </div>
        </div>
      </PaymentLogos>
    </Container>
  )
}

export default Sponsors
